<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDataTransfer } from 'dashboard/composables/useDataTransfer';

import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const { downloadExample } = useDataTransfer();

const tips = computed(() => [
  t('DATA_TRANSFER.TUTORIAL.TIP_LIMIT'),
  t('DATA_TRANSFER.TUTORIAL.TIP_VALUE'),
  t('DATA_TRANSFER.TUTORIAL.TIP_UTF8'),
  t('DATA_TRANSFER.TUTORIAL.TIP_EXISTING'),
  t('DATA_TRANSFER.TUTORIAL.TIP_LABELS'),
  t('DATA_TRANSFER.TUTORIAL.TIP_NAME'),
  t('DATA_TRANSFER.TUTORIAL.TIP_LISTS'),
  t('DATA_TRANSFER.TUTORIAL.TIP_DUPLICATES'),
  t('DATA_TRANSFER.TUTORIAL.TIP_DEALS'),
  t('DATA_TRANSFER.TUTORIAL.TIP_EXCEL'),
  t('DATA_TRANSFER.TUTORIAL.TIP_PHONE'),
  t('DATA_TRANSFER.TUTORIAL.TIP_BATCH_LABEL'),
]);
const exampleRows = [
  ['Proposta de site', 'Maria Souza', 'Acme Ltda'],
  ['—', 'João Lima', '—'],
  ['—', 'Carla Dias', 'Beta Corp'],
];
</script>

<template>
  <div
    class="w-[26rem] max-w-[90vw] max-h-[28rem] overflow-y-auto p-4 text-sm rounded-xl shadow-lg bg-n-solid-2 outline outline-1 outline-n-weak text-n-slate-12"
  >
    <h4 class="mb-2 text-sm font-medium">
      {{ t('DATA_TRANSFER.TUTORIAL.TITLE') }}
    </h4>
    <ol class="flex flex-col gap-2 pl-4 mb-3 list-decimal text-n-slate-11">
      <li>{{ t('DATA_TRANSFER.TUTORIAL.ROW_MEANING') }}</li>
      <li>{{ t('DATA_TRANSFER.TUTORIAL.CREATE_DEAL') }}</li>
      <li>{{ t('DATA_TRANSFER.TUTORIAL.LINK_CONTACT') }}</li>
      <li>{{ t('DATA_TRANSFER.TUTORIAL.EXACT_NAMES') }}</li>
    </ol>

    <table class="w-full mb-3 text-xs border-collapse">
      <thead class="bg-n-alpha-1">
        <tr>
          <th class="px-2 py-1 text-left border border-n-weak">
            {{ t('DATA_TRANSFER.TUTORIAL.TABLE.DEAL') }}
          </th>
          <th class="px-2 py-1 text-left border border-n-weak">
            {{ t('DATA_TRANSFER.TUTORIAL.TABLE.CONTACT') }}
          </th>
          <th class="px-2 py-1 text-left border border-n-weak">
            {{ t('DATA_TRANSFER.TUTORIAL.TABLE.COMPANY') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in exampleRows" :key="index">
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            class="px-2 py-1 border border-n-weak text-n-slate-11"
          >
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>

    <Button
      :label="t('DATA_TRANSFER.TUTORIAL.DOWNLOAD_EXAMPLE')"
      icon="i-lucide-download"
      color="slate"
      variant="faded"
      size="sm"
      type="button"
      class="mb-3"
      @click="downloadExample"
    />

    <p class="mb-1 text-xs font-medium uppercase text-n-slate-11">
      {{ t('DATA_TRANSFER.TUTORIAL.TIPS_TITLE') }}
    </p>
    <ul
      class="flex flex-col gap-1.5 pl-4 mb-3 text-xs list-disc text-n-slate-11"
    >
      <li v-for="tip in tips" :key="tip">
        {{ tip }}
      </li>
    </ul>
  </div>
</template>
